/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ browser: NonNullable<unknown> }} Extension_Ctadownload1Inputs */

const he_extension_ctadownload1 = /** @type {(inputs: Extension_Ctadownload1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`הורד ל-${i?.browser}`)
};

const en_extension_ctadownload1 = /** @type {(inputs: Extension_Ctadownload1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download for ${i?.browser}`)
};

/**
* | output |
* | --- |
* | "Download for {browser}" |
*
* @param {Extension_Ctadownload1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_ctadownload1 = /** @type {((inputs: Extension_Ctadownload1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Ctadownload1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_ctadownload1(inputs)
	return en_extension_ctadownload1(inputs)
});
export { extension_ctadownload1 as "extension_ctaDownload" }